import React from 'react';
import { Offer } from 'cityads-v3/types/offers';
import { CardActionButton } from 'cityads-v3/components/Card/CardTypes';
import { ViewVariants } from 'cityads-v3/components/ViewSelector/ViewSelector';

import OffersListCards from './OffersListCards';
import OffersListTable from './OffersListTable';

export type OffersListProps = {
  customActions: CardActionButton[],
  customBody: () => JSX.Element,
  customCardTitle: () => JSX.Element,
  isFavoritesPage: boolean,
  linkSource: string | { name: string, url: string },
  offers: Offer[],
  reloadFavoriteTotalCount: () => void,
  showActions: boolean,
  showTargetsTable: boolean,
  view: ViewVariants
}

export default function OffersList({
  ...rest
}: OffersListProps): JSX.Element {
  return ['list', 'cards'].includes(rest.view) ? <OffersListCards {...rest} /> : <OffersListTable {...rest} />
}
